import React, { useContext } from 'react'

import { PaymentErrorContext } from '../AppContext'

const PaymentError = () => {

  const [ paymentError ] = useContext(PaymentErrorContext)

  return (
    <div>
      Oh no! Something went wrong... {paymentError}
    </div>
  )
}

export default PaymentError